var vueIfExists = function(config) {
	var id = '';
	if (config.el[0] == '#') {
		// if el contains an id, check with getElementById because it is fast 
		id = config.el.match(/#([_a-zA-Z0-9-]+)/)[1];
		if (!document.getElementById(id)) return;
	}
	if ((id && id == '#'+config.el) || document.querySelector(config.el)) {
		if (win.vueConfigStored && win.vueConfigStored[config.el]) {
			config = win.vueConfigStored[config.el];
		}
		return new Vue(config);
	}
};